/*
  shipping-progress.js
  ─────────────────────
  Live-opdatering af fragt-progressbaren (shipping-progress-bar.liquid).
  Upload til temaets Assets-mappe. Snippet'et indlæser filen automatisk.

  Baren genberegnes klientside når kurven ændres via AJAX — uden fuld
  sideindlæsning. Konfiguration læses fra <script type="application/json">
  inde i hvert .shipping-progress-element, så ingen indstillinger er
  hardkodet her. Vanilla JS, ingen afhængigheder.
*/
(function () {
  'use strict';

  // Beskyt mod dobbelt-eksekvering (snippet'et kan optræde flere gange pr. side).
  if (window.ShippingProgress) return;

  // ── Pengeformatering (Shopify standard money_format) ───────────────────────
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    function withDelimiters(precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return integer + fraction;
    }

    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(2); break;
      case 'amount_no_decimals': value = withDelimiters(0); break;
      case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(2, "'", '.'); break;
      default: value = withDelimiters(2);
    }
    return fmt.replace(placeholder, value);
  }

  // HTML-escape af etiketter (admin-styret tekst, men escapes for en sikkerheds skyld).
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  // ── Beregn aktivt trin + progress (spejler logikken i .liquid) ──────────────
  function compute(totalCents, cfg) {
    var amounts = cfg.amounts.map(function (a) { return Math.round(parseFloat(a) * 100); });
    var n = amounts.length;
    var activeIdx = n;          // sentinel: n == alle trin nået (åben top-tier)
    var activeCents = 0;
    var prevCents = 0;
    var progress = 100;
    var allDone = true;

    for (var i = 0; i < n; i++) {
      if (totalCents < amounts[i]) {
        activeIdx = i;
        activeCents = amounts[i];
        allDone = false;
        break;
      }
    }

    if (!allDone) {
      if (activeIdx > 0) prevCents = amounts[activeIdx - 1];
      var span = activeCents - prevCents;
      var fill = totalCents - prevCents;
      progress = span > 0 ? Math.round((fill * 100) / span) : 100;
      if (progress < 0) progress = 0;
      if (progress > 100) progress = 100;
    }

    return {
      amounts: amounts,
      activeIdx: activeIdx,
      activeCents: activeCents,
      progress: progress,
      allDone: allDone
    };
  }

  // ── Byg notice-teksten for det aktive trin ─────────────────────────────────
  // Beskeder er pr. trin (cfg.messages), åben top-tier i cfg.openMessage.
  // {amount} = resterende beløb til trinnets øvre grænse.
  function buildText(state, totalCents, cfg) {
    if (state.allDone) {
      return (cfg.openMessage || '').replace(/\{amount\}/g, '');
    }
    var amtHtml = '<strong>' + formatMoney(state.activeCents - totalCents, cfg.moneyFormat) + '</strong>';
    var tmpl = cfg.messages[state.activeIdx] || '';
    return tmpl.replace(/\{amount\}/g, amtHtml);
  }

  // ── Opdatér ét element ──────────────────────────────────────────────────────
  function updateEl(el, totalCents) {
    var cfg = el.__spCfg;
    if (!cfg) return;

    var state = compute(totalCents, cfg);

    // Synlighed: skjul i drawer/kurv når kurven er tom, vis igen ved varer.
    if (cfg.hideWhenEmpty) {
      if (totalCents <= 0) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    }

    // Tekst
    var textEl = el.querySelector('.shipping-progress__text');
    if (textEl) textEl.innerHTML = buildText(state, totalCents, cfg);

    // Bar
    if (cfg.amounts.length > 1) {
      var segs = el.querySelectorAll('.shipping-progress__segment');
      Array.prototype.forEach.call(segs, function (seg, i) {
        seg.classList.remove('shipping-progress__segment--done', 'shipping-progress__segment--pending');
        seg.style.removeProperty('--sp-seg-progress');
        if (state.allDone || i < state.activeIdx) {
          seg.classList.add('shipping-progress__segment--done');
        } else if (i === state.activeIdx) {
          seg.style.setProperty('--sp-seg-progress', state.progress + '%');
        } else {
          seg.classList.add('shipping-progress__segment--pending');
        }
      });
    } else {
      var bar = el.querySelector('.shipping-progress__bar');
      if (bar) bar.style.setProperty('--sp-progress', state.progress + '%');
    }

    // ARIA
    var ariaMax = state.allDone
      ? (state.amounts[state.amounts.length - 1] || 0)
      : state.activeCents;
    var ariaLabel = textEl ? textEl.textContent.trim() : '';
    var bars = el.querySelectorAll('[role="progressbar"]');
    Array.prototype.forEach.call(bars, function (pb) {
      pb.setAttribute('aria-valuenow', totalCents);
      pb.setAttribute('aria-valuemax', ariaMax);
      pb.setAttribute('aria-label', ariaLabel);
    });
  }

  // ── Init: parse config-blob på hvert element én gang ────────────────────────
  function init() {
    var els = document.querySelectorAll('[data-shipping-progress]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.__spInit) return;
      var script = el.querySelector('[data-shipping-progress-config]');
      if (!script) return;
      try {
        el.__spCfg = JSON.parse(script.textContent);
        el.__spInit = true;
      } catch (e) {
        /* ugyldig config — spring elementet over */
      }
    });
  }

  function refreshAll(totalCents) {
    var els = document.querySelectorAll('[data-shipping-progress]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.__spInit) updateEl(el, totalCents);
    });
  }

  // Hent den autoritative kurvtotal og opdatér. Debounces så bursts kollapser.
  function fetchAndRefresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        init();
        refreshAll(cart.total_price);
      })
      .catch(function () { /* netværksfejl — behold serverrenderet tilstand */ });
  }

  var timer = null;
  function scheduleRefresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(fetchAndRefresh, 150);
  }

  // ── Detektér kurvændringer fra flere kilder ─────────────────────────────────

  // 1. Almindelige custom events som mange temaer udsender.
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (ev) {
    document.addEventListener(ev, scheduleRefresh);
  });

  // 2. Online Store 2.0 / Dawn pub-sub.
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  }

  // 3. Fald-tilbage: opfang AJAX-kald til kurv-endpoints (dækker temaer uden events).
  if (window.fetch && !window.fetch.__spPatched) {
    var origFetch = window.fetch;
    var patched = function () {
      var url = arguments[0];
      if (url && typeof url !== 'string' && url.url) url = url.url;
      var promise = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        promise.then(function () { scheduleRefresh(); }).catch(function () {});
      }
      return promise;
    };
    patched.__spPatched = true;
    window.fetch = patched;
  }

  // Offentligt API til manuel opdatering fra temaets egen kode.
  window.ShippingProgress = {
    refresh: scheduleRefresh,
    update: function (totalCents) { init(); refreshAll(totalCents); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
